<template>
    <div>
    <ListCycle v-if="isMainRoute"></ListCycle>
    <router-view></router-view>
    </div>
</template>

<script>
import ListCycle from "@/components/cyclic/cycle/List"

export default {
  name: "MainView",
  components: {
    ListCycle
  },
  data: () => ({
    isMainRoute: true
  }),
  computed: {},
  watch: {
    '$route.name': function (name) {
      this.isMainRoute = name == 'cycle-list'
    }
  },
  created() {
    this.isMainRoute = this.$router.currentRoute.name == 'cycle-list'
  },
  methods: {},
}
</script>

<style scoped>

</style>